import moment from 'moment'
import config from 'services/config'

export default {
    computed: {
        isInSummitTimeRange () {
            return moment().unix() > config.summitStart && moment().unix() < config.summitEnd
        }
    }
}
